import { Microfrontend } from '@thoughtspot/microfrontends';
import { prefetchMicroFrontend } from './mfe-prefetch';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';

enum NavigationComponents {
    NavigationHub = 'NavigationHub',
    QuickLinkContainer = 'QuickLinkContainer',
}

export const NavigationHub = loadMicroFrontendComponent(
    Microfrontend.NAVIGATION,
    NavigationComponents.NavigationHub,
);

export const QuickLinkContainer = loadMicroFrontendComponent(
    Microfrontend.NAVIGATION,
    NavigationComponents.QuickLinkContainer,
);

prefetchMicroFrontend(Microfrontend.NAVIGATION);
